import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Row } from '../../../common/components/elements';
import { ReactComponent as FoodIcon } from '../../../../svg/icon_top_cities.svg';

interface Props {
  title: string;
  desc: string;
  icon?: any;
}

const HomeBoxHeading: React.FC<Props> = (props: Props) => {
  const { title, desc, icon } = props;
  return (
    <Row>
      {icon ? <img style={{ width: 48 }} src={icon} alt="food icon" /> : <FoodIcon />}
      <div style={{ marginLeft: 10 }}>
        <Typography
          style={{
            color: '#000',
            fontWeight: 'bold',
            marginBottom: '6px',
            marginTop: '10px',
            fontSize: '16px',
            lineHeight: '21px',
            textTransform: 'uppercase',
          }}
          variant="h4"
        >
          {title}
        </Typography>
        <Typography
          style={{
            color: '#000',
            fontSize: '14px',
            lineHeight: '18px',
            marginBottom: '15px',
          }}
          variant="body1"
        >
          {desc}
        </Typography>
      </div>
    </Row>
  );
};

export default HomeBoxHeading;
